(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/hooks-wager/assets/javascripts/use-get-all-participant-names-by-wager-id.js') >= 0) return;  svs.modules.push('/components/tipsen/hooks-wager/assets/javascripts/use-get-all-participant-names-by-wager-id.js');
"use strict";


const useGetAllParticipantNamesByDrawId = svs.components.tipsen.hooks.useGetAllParticipantNamesByDrawId;
const useGetWagerDraw = svs.components.tipsen.hooksWager.useGetWagerDraw;
const useGetAllParticipantNamesByWagerId = _ref => {
  let wagerId = _ref.wagerId;
  const _useGetWagerDraw = useGetWagerDraw({
      wagerId
    }),
    draw = _useGetWagerDraw.draw;
  const _ref2 = draw || {},
    productId = _ref2.productId,
    drawNumber = _ref2.drawNumber;
  const participantNames = useGetAllParticipantNamesByDrawId("".concat(productId, "_").concat(drawNumber));
  return participantNames;
};
setGlobal('svs.components.tipsen.hooksWager.useGetAllParticipantNamesByWagerId', useGetAllParticipantNamesByWagerId);

 })(window);